import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "cTiCAi",
    defaultMessage: "Import Data",
  },

  // Wizard step labels
  stepConfigure: {
    id: "Db2MC3",
    defaultMessage: "Import Settings",
  },
  stepUpload: {
    id: "udcd2v",
    defaultMessage: "Upload & Import",
  },

  // Step 0: Configure
  sectionTemplate: {
    id: "/vMjn3",
    defaultMessage: "Download Template",
  },
  templateDescription: {
    id: "/WEFaZ",
    defaultMessage:
      "Download the XLSX template, fill it in with your data, then upload it in the next step.",
  },
  downloadTemplateButton: {
    id: "csH64t",
    defaultMessage: "Download Template (.xlsx)",
  },

  sectionLanguage: {
    id: "/CCEZI",
    defaultMessage: "Content Language",
  },
  languageDescription: {
    id: "9/59Kr",
    defaultMessage:
      "Select the language of the content in your import file. This will be used to set the correct translation for all imported records.",
  },

  sectionChannel: {
    id: "7Q6iDW",
    defaultMessage: "Channel listing",
  },
  channelDescription: {
    id: "2Mig2c",
    defaultMessage:
      "Choose a channel to publish imported variants there. Leave this blank to import without adding channel listings.",
  },
  noChannelSelected: {
    id: "5zD5Sa",
    defaultMessage: "No channel (import without channel listings)",
  },

  sectionDuplicate: {
    id: "nbl7Yp",
    defaultMessage: "Duplicate Handling",
  },
  strategyUpdate: {
    id: "BWpuKl",
    defaultMessage: "Update",
  },
  strategyUpdateDesc: {
    id: "n9wCzK",
    defaultMessage: "Overwrite existing records with the data in the file.",
  },
  strategySkip: {
    id: "/4tOwT",
    defaultMessage: "Skip",
  },
  strategySkipDesc: {
    id: "amidaj",
    defaultMessage: "Leave existing records untouched; only create new ones.",
  },
  strategyError: {
    id: "KN7zKn",
    defaultMessage: "Error",
  },
  strategyErrorDesc: {
    id: "q8tk1e",
    defaultMessage: "Fail the entire row if a matching record already exists.",
  },

  // Step 1: Upload
  sectionUpload: {
    id: "W/66A1",
    defaultMessage: "Upload Filled Template",
  },
  uploadDescription: {
    id: "D6wf6g",
    defaultMessage: "Select the completed .xlsx file to import. Processing runs in the background.",
  },
  chooseFile: {
    id: "tyilHQ",
    defaultMessage: "Choose File",
  },
  noFileSelected: {
    id: "KWwyi1",
    defaultMessage: "No file selected",
  },

  sectionSummary: {
    id: "FIasGd",
    defaultMessage: "Import Summary",
  },
  summaryType: {
    id: "l/WZz6",
    defaultMessage: "Import type",
  },
  summaryDuplicate: {
    id: "hyuS6t",
    defaultMessage: "Duplicate handling",
  },
  summaryLanguage: {
    id: "zetZX8",
    defaultMessage: "Content language",
  },
  summaryChannel: {
    id: "7Q6iDW",
    defaultMessage: "Channel listing",
  },
  resultSummary: {
    id: "xh79JO",
    defaultMessage: "Results by sheet",
  },
  resultSummaryLine: {
    id: "hv7yQX",
    defaultMessage: "{ok} imported · {skipped} skipped · {errors} errors",
  },
  toastIssuesTitle: {
    id: "e+T2ux",
    defaultMessage: "Import completed with issues",
  },
  toastIssuesText: {
    id: "wQJF5C",
    defaultMessage:
      "Some rows were skipped or failed. Review the per-sheet counts and download the result report.",
  },
  noRowsProcessed: {
    id: "S1JP0i",
    defaultMessage:
      "The import completed, but no rows were processed. Check that the workbook contains the expected sheets and data.",
  },
  missingSheet: {
    id: "9iRVm3",
    defaultMessage: "Sheet missing; no rows were imported",
  },
  moreErrors: {
    id: "zQgr/p",
    defaultMessage: "{count} more row errors are listed in the result Excel.",
  },
  moreSkips: {
    id: "scE7wS",
    defaultMessage: "{count} more skipped rows are listed in the result Excel.",
  },

  submitImport: {
    id: "9XUYQt",
    defaultMessage: "Import",
  },

  importSuccess: {
    id: "mO8pv4",
    defaultMessage: "Import completed successfully.",
  },
  importFailed: {
    id: "qDqjB9",
    defaultMessage: "Import finished with errors. Download the result file to review.",
  },
  downloadResult: {
    id: "L6xFmt",
    defaultMessage: "Download Result File",
  },

  // Toast notifications
  toastStartedTitle: {
    id: "cvyaXP",
    defaultMessage: "Import started",
  },
  toastStartedText: {
    id: "VEQqvN",
    defaultMessage:
      "Your file is being processed in the background. You will be notified when it finishes.",
  },
  toastSuccessTitle: {
    id: "TNaDyA",
    defaultMessage: "Import complete",
  },
  toastSuccessText: {
    id: "g4KHN8",
    defaultMessage: "All rows were imported successfully.",
  },
  toastFailedTitle: {
    id: "RHXAvJ",
    defaultMessage: "Import finished with errors",
  },
  toastFailedText: {
    id: "6az8xR",
    defaultMessage: "Some rows could not be imported. Download the result file for details.",
  },
  toastErrorTitle: {
    id: "Yj5wok",
    defaultMessage: "Import failed",
  },
});
